import React, {useRef, useEffect} from 'react';
import './KindergartensTable.css';

const KindergartensTable = ({tableData, isChecked, onCheck, listChecked, uncheckAll, isFixed}) => {
  const tableData_ = [
    {
      id: 1,
      name: "Заклад дошкільної освіти №530",
      district: "Святошинський",
      address: "вул. Мстислава Скрипника, 40",
      phone: "099-327-42-49",
      variant: "default"
    },
    {
      id: 2,
      name: "Заклад дошкільної освіти №530",
      district: "Святошинський",
      address: "вул. Мстислава Скрипника, 40",
      phone: "099-327-42-49",
      variant: "alternate"
    },
    {
      id: 3,
      name: "Заклад дошкільної освіти №215 «Дитя...»",
      district: "Подільський",
      address: "вул. Костянтинівська, 21",
      phone: "099-123-45-67",
      variant: "default"
    },
    {
      id: 4,
      name: "Заклад дошкільної освіти №530",
      district: "Святошинський",
      address: "вул. Мстислава Скрипника, 40",
      phone: "099-327-42-49",
      variant: "alternate"
    },
    {
      id: 5,
      name: "Заклад дошкільної освіти №530",
      district: "Святошинський",
      address: "вул. Мстислава Скрипника, 40",
      phone: "099-327-42-49",
      variant: "info"
    },
    {
      id: 6,
      name: "Заклад дошкільної освіти №530",
      district: "Святошинський",
      address: "вул. Мстислава Скрипника, 40",
      phone: "099-327-42-49",
      variant: "default"
    },
    {
      id: 7,
      name: "Заклад дошкільної освіти №520 «Зіро...»",
      district: "Солом'янський",
      address: "вул. Стефаника, 8",
      phone: "099-158-69-25",
      variant: "default"
    },
    {
      id: 8,
      name: "Заклад дошкільної освіти №530",
      district: "Святошинський",
      address: "вул. Мстислава Скрипника, 40",
      phone: "099-327-42-49",
      variant: "alternate"
    },
    {
      id: 9,
      name: "Заклад дошкільної освіти №204 «Виш...»",
      district: "Голосіївський",
      address: "вул. Вишнева, 22",
      phone: "099-342-78-56",
      variant: "default"
    },
    {
      id: 10,
      name: "Заклад дошкільної освіти №312 «Мале...»",
      district: "Подільський",
      address: "вул. Поштовий, 10",
      phone: "099-948-73-12",
      variant: "alternate"
    }
  ];

  const getRowClass = (i) => {

    const variant = i % 2 ?  "alternate" : "info"  ;

    switch (variant) {
      case 'alternate':
        return 'table-alternate';
      case 'info':
        return 'table-info';
      default:
        return '';
    }
  };

  const incheckRef = useRef();


  useEffect(()=>{if(listChecked.length > 0) incheckRef.current.indeterminate = true}, [listChecked]);


  return (
    <div className="table-responsive">
      <table className="table kindergartens-table">
        <thead>
          <tr>
            {isChecked && <th style={{ width: '36px' }}>  <input
                    type="checkbox"
                    onChange={uncheckAll}
                    checked={false}
                    className="table-list-uncheck-button"
                    disabled={isFixed}
                    ref={incheckRef}
                  /></th>}
            <th>Назва закладу</th>
            <th>Район</th>
            <th>Адреса</th>
            <th>Телефон</th>
            <th>Дії</th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((kindergarten, i) => (
            <tr key={kindergarten._id} className={`${getRowClass(i)} ${listChecked.includes(kindergarten._id) ? 'selected' : ''}`}>
              {isChecked && <td>
                  <input
                    type="checkbox"
                    checked={listChecked.includes(kindergarten._id)}
                    onChange={() => {onCheck(kindergarten._id)}}
                    disabled={isFixed}
                  />
              </td>}
              <td>{[kindergarten.number, kindergarten.name].join(" ")}</td>
              <td>{kindergarten.contacts.address.district}</td>
              <td>{kindergarten.contacts.address.string}</td>
              <td>{kindergarten.contacts.phones.join(",")}</td>
              <td>
                  <a href={`/object/${kindergarten._id}`} className="btn-link-blue">Переглянути</a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default KindergartensTable;